
export default {
  name: 'CustomAccordion',
  props: {
    headerClass: {
      type: String,
      default: '',
    },
    keyField: {
      type: String,
      default: '',
    },
    isSingle: {
      type: Boolean,
      default: true,
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    itemShowHeader: {
      type: Function,
      default: null,
    },
    itemDisabled: {
      type: Function,
      default: null,
    },
    itemExpanded: {
      type: Function,
      default: null,
    },
    itemToggled: {
      type: Function,
      default: null,
    },
    name: {
      type: String,
      default: '',
    },
    appear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internal_expanded: this.items.find((item) => item.isExpanded),
    };
  },
  methods: {
    beforeEnter(el) {
      el.style.height = 0;
    },

    enter(el, done) {
      el.style.height = `${el.scrollHeight}px`;
      setTimeout(() => {
        el.style.height = 'auto';
        done();
      }, 300);
    },

    beforeLeave(el) {
      el.style.height = `${el.scrollHeight}px`;
    },

    leave(el, done) {
      this.$nextTick(() => {
        el.style.height = 0;
        setTimeout(done, 250);
      });
    },

    toggleSelection(item) {
      if (this.itemToggled) {
        this.itemToggled(item);
        this.$forceUpdate();
        return;
      }
      this.internal_expanded = this.internal_expanded !== item ? item : null;
    },

    isExpanded(item) {
      return this.itemExpanded ? this.itemExpanded(item) : this.internal_expanded === item;
    },

    isDisabled(item) {
      return this.itemDisabled ? this.itemDisabled(item) : false;
    },

    showHeader(item) {
      return this.itemShowHeader ? this.itemShowHeader(item) : true;
    },

    headerKeyDown(e) {
      const { target, ctrlKey } = e;
      const { length } = this.$refs.header;
      const key = e.which.toString();

      // Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
      // 33 = Page Up, 34 = Page Down
      // 38 = Up, 40 = Down
      if (key.match(/38|40/) || (key.match(/33|34/) && ctrlKey)) {
        const index = this.$refs.header.indexOf(target);
        const direction = key.match(/34|40/) ? 1 : -1;
        const newIndex = (index + length + direction) % length;
        this.$refs.header[newIndex].focus();
        e.preventDefault();
      } else if (key.match(/35|36/)) {
        // 35 = End, 36 = Home keyboard operations
        switch (key) {
          // Go to first accordion
          case '36':
            this.$refs.header[0].focus();
            break;
          // Go to last accordion
          case '35':
            this.$refs.header[length - 1].focus();
            break;
        }
        e.preventDefault();
      }
    },
    idPanel(index) {
      return `accordion-panel-${this.name}-${index}`
    },
    idHeader(index) {
      return `accordion-header-${this.name}-${index}`
    },
  },
};
